<style lang="less" scoped>

</style>
<template>
  <v-autocomplete
    :value="value"
    :rules="rules"
    :label="label"
    item-value="id"
    :items="filter_banks"
    :item-text="itemTextFunc"
    :item-disabled="itemDisabledFunc"
    :placeholder="calc_placeholder"
    :no-data-text="!companyId&&'请先选择公司' || ''"
    @change="change"
  >
    <template v-slot:label> 
      <span><span
        v-show="required"
        style="color:red"
      >*</span>{{ label }}</span>
    </template>
  </v-autocomplete>
</template>
<script>
  import {mapGetters} from "vuex";

  export default {
    props: {
      required: {
        type: Boolean,
      },
      value: {
        type: Number
      },
      label: {
        type: String,
        default: '银行账户'
      },
      rules: {
        type: Array,
        default() {
          return [];
        }
      },
      placeholder: {
        type: String,
        default: '请选择我方银行账户'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      companyId: {
        type: [Number, String],
      },
      canCrossCompany: {
        type: Boolean,
        default: false
      },
      checkPaymentFinBill: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters({
        banks: 'async/banks',
        banks_hash: 'async/banks_hash',
      }),
      filter_banks() {
        return this.banks.filter((item) => {
          return this.canShowItem(item);
        })
      },
      calc_placeholder() {
        const bank = this.banks_hash[this.value];
        return bank ? this.itemTextFunc(bank) : this.placeholder;
      }
    },
    methods: {
      getFilterBanks() {
        return this.filter_banks
      },
      canShowItem(item) {
        return this.canCrossCompany || (this.companyId && this.companyId === item.company_id);
      },
      itemTextFunc(b) {
        let text = `${b.bank_number}-${b.account}-${b.bank}`;
        if (b.del) {
          text += ' (已弃用)';
        } else if (this.checkPaymentFinBill && !b.payment_fin_bill_kind) {
          text += ' (关联财务单据后可选)';
        }
        return text;
      },
      itemDisabledFunc(b) {
        if (b.del) return true;
        if (this.checkPaymentFinBill && !b.payment_fin_bill_kind) return true;
      },
      change(id) {
        const bank = this.banks_hash[id];
        if (bank) {
          this.$emit('change', bank);
          this.$emit('input', id);
        }
        document.body.click();
      },
    }
  }
</script>
